import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import showToast from "../Hot-Toast/showToast";
import IMAGE from "../../assets/images/big/abcz.png";
import { axiosInstance } from "../../utils/axiosInstance"; 
import LOGO from "../../../src/assets/images/big/empowercarelogo.png"

const JobOfferEmailView = () => {
  const navigate = useNavigate();
  const { userId, jobId } = useParams();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [jobData, setJobData] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  // Fetch job offer details
  useEffect(() => {
    fetchJobOfferDetails();
  }, [userId, jobId]);

const fetchJobOfferDetails = async () => {
  try {
    setLoading(true);
    setError(null);

    const response = await axiosInstance.get(
      "/job/fetchClinicianJobDetail",
      {
        params: {
          clinicianId: userId,
          jobId: jobId,
        },
      }
    );

    if (response?.data?.STATUS) {
      setJobData(response.data.OUTPUT);
    } else {
      setError(
        response?.data?.MESSAGE || "Failed to fetch job offer details"
      );
    }
  } catch (err) {
    console.error("Error fetching job offer:", err);
    setError(
      err?.response?.data?.MESSAGE || "Error fetching job offer details"
    );
  } finally {
    setLoading(false);
  }
};

  const handleActionClick = (action) => {
    setPendingAction(action);
    setShowConfirmDialog(true);
  };

  const handleConfirmAction = async () => {
    setShowConfirmDialog(false);
    try {
      setActionLoading(true);

      const response = await axiosInstance.post(
        "/job/clinicianRespondToJobOffer",
        {
          clinicianId: userId,
          jobId: jobId,
          action: pendingAction === "Accept" ? "accept" : "reject",
        }
      );

      if (response?.data?.STATUS) {
        showToast(
          "success",
          `Offer ${pendingAction === "Accept" ? "accepted" : "rejected"} successfully`
        );
        
        // Redirect to login after success
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        showToast("error", response?.data?.MESSAGE || "Something went wrong");
      }
    } catch (err) {
      console.error("Error processing action:", err);
      showToast(
        "error",
        err?.response?.data?.MESSAGE || "Something went wrong. Please try again."
      );
    } finally {
      setActionLoading(false);
      setPendingAction(null);
    }
  };

  // Loading state
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Grid container style={{ marginTop: 60 }} justifyContent="center" pb={18}>
        <Grid lg={8}>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
          <Button
            variant="contained"
            onClick={() => navigate("/login")}
            sx={{ mt: 2 }}
          >
            Go to Login
          </Button>
        </Grid>
      </Grid>
    );
  }

  // Check if job offer is already accepted/rejected
  const isOfferResolved =
    jobData?.cliniciansInFacilityJobShifts?.some(
      (shift) =>
        shift?.offerStatus === "OfferAccepted" ||
        shift?.offerStatus === "OfferRejected"
    );

  return (
    <>
      {/* Minimal Header with Logo */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e0e0e0",
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
        }}
      >
         <Box mt={0.5} sx={{ transition: "opacity 0.3s ease-in-out" }}>
                    {(
                      <img
                        src={LOGO}
                        alt="logo"
                        width="183.54px"
                        height="30px"
                        // style={mobileMedia ? { marginTop: "auto" } : {}}
                        onClick={() => navigate("/login")}
                      />
                    )}
                  </Box>

        {/* <Box sx={{ width: 50, height: 50 }}>
          <img src={IMAGE} alt="logo" style={{ width: "100%", height: "100%" }} />
        </Box> */}
      </Box>

      <Grid container style={{ marginTop: 20 }} justifyContent="center" pb={18}>
        <Grid lg={8}>
          <Card>
            <Grid
              container
              alignItems="center"
              spacing={1}
              justifyContent="space-around"
              px={3}
              pt={2}
            >
              <Grid item xs={12} sm={12} display="flex" gap={3}>
                <Typography pt={2}>
                  <img src={IMAGE} alt="lt" />
                </Typography>
                <Typography>
                  <Box pt={2}>
                    <Typography
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#000000",
                        opacity: "87%",
                      }}
                    >
                      {jobData?.user?.FACILITY_NAME}
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        color: "#000000",
                        opacity: "60%",
                      }}
                    >
                      {jobData?.user?.STREET_ADDRESS}
                    </Typography>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  sx={{
                    fontSize: "18px",
                    color: "rgba(0,0,0,0.87)",
                    fontWeight: 700,
                  }}
                >
                  {jobData?.ROLE_NAME}
                </Typography>
              </Grid>
            </Grid>

            <hr
              style={{
                marginTop: "20px",
                color: "#000000",
                opacity: "60%",
                width: "90%",
                margin: "0 auto",
              }}
            />

            {/* Job Details */}
            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Title:{" "}
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.jobs_role?.ROLE_NAME}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Specialty:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.specialty?.SPECIALTY_NAME}
              </Typography>
            </Box>

            {jobData?.STAFFING_SOLUTION && (
              <Box display="flex" px={2} pt={1.2}>
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#000000",
                    opacity: "87%",
                  }}
                >
                  Staffing Solution:
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#000000",
                    opacity: "60%",
                    paddingLeft: "3px",
                  }}
                >
                  {jobData?.STAFFING_SOLUTION}
                </Typography>
              </Box>
            )}

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Job Type:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.JOB_TYPE}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Shift Type:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.SERVICE_TYPE}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Start Date:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {new Date(jobData?.SERVICE_DATE).toDateString()}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                End Date:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {new Date(jobData?.SERVICE_END_DATE).toDateString()}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Working Days:
              </Typography>
              <Button onClick={() => setOpen(true)}>
                Job Service (Date & Time)
              </Button>
            </Box>

            <Box display="flex" px={2} pt={1.2} pb={2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Pay:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "#000000",
                  // opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.cliniciansInFacilityJobShifts?.length > 0
                  ? `$${jobData.cliniciansInFacilityJobShifts[0]?.clinicianPayRate}/hr`
                  : `$${jobData?.PAY_AMOUNT_FROM}-$${jobData?.PAY_AMOUNT_TO}/hr`}
              </Typography>
            </Box>
          </Card>

          {/* Facility Details */}
          <Box style={{ marginTop: 20 }}>
            <Card>
              <Grid
                container
                alignItems="center"
                spacing={1}
                justifyContent="space-around"
                p={3}
                pb={3}
              >
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="h5"
                    style={{ fontWeight: 600, fontSize: "18px", color: "#000" }}
                  >
                    Facility Details
                  </Typography>
                  <Typography
                    style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
                  >
                    <strong>Recruiter Name:</strong>{" "}
                    {jobData?.user?.FULL_NAME || "N/A"}
                  </Typography>
                  <Typography
                    style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
                  >
                    <strong>Recruiter Email:</strong>{" "}
                    {jobData?.user?.EMAIL_ADDRESS || "N/A"}
                  </Typography>
                  <Typography
                    style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
                  >
                    <strong>Recruiter Phone:</strong>{" "}
                    {jobData?.user?.PHONE_NUMBER || "N/A"}
                  </Typography>
                  <Typography
                    style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
                  >
                    <strong>Facility Name:</strong>{" "}
                    {jobData?.user?.FACILITY_NAME || "N/A"}
                  </Typography>
                  <Typography
                    style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
                  >
                    <strong>Location:</strong>{" "}
                    {jobData?.user?.STREET_ADDRESS || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Box>

          {/* Job Description */}
          <Box style={{ marginTop: 20 }}>
            <Card>
              <Grid
                container
                alignItems="center"
                spacing={1}
                justifyContent="space-around"
                p={3}
                pb={3}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#000000",
                      opacity: "87%",
                    }}
                  >
                    Job Description
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography
                    id="delete-modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                      fontWeight: 400,
                      fontSize: "16px",
                      color: "#000000",
                      opacity: "60%",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: jobData?.JOB_DESCRIPION,
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} mt={3}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="h3"
                      style={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#000000",
                        opacity: "87%",
                      }}
                    >
                      Responsibilities:
                    </Typography>
                  </Box>

                  <Typography pt={1}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: jobData?.JOB_RESPONSIBILITY,
                      }}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
      </Grid>

      {/* Job Service Dialog */}
      {open && (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogContent className="max-w-3xl">
            <DialogTitle>
              Job Services
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <div className="space-y-2">
              {jobData?.jobSchedule?.SERVICE_DURATION?.length > 0 ? (
                jobData.jobSchedule.SERVICE_DURATION.map((service, index) => (
                  <div
                    key={service.ID || index}
                    className="p-2 border rounded"
                  >
                    <p>
                      <strong>Day:</strong> {service.JOB_DAY || "N/A"}
                    </p>
                    <p>
                      <strong>In Time:</strong>{" "}
                      {service.JOB_IN_TIME || "N/A"}
                    </p>
                    <p>
                      <strong>Out Time:</strong>{" "}
                      {service.JOB_OUT_TIME || "N/A"}
                    </p>
                  </div>
                ))
              ) : (
                <p>Schedule is yet to be defined by Facility.</p>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}

      {/* Action Buttons */}
      {!isOfferResolved && (
        <Grid
          container
          sx={{
            backgroundColor: "white",
            width: "100%",
            overflowX: "hidden",
            position: "sticky",
            bottom: 0,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Grid item xs={12} sm={12} style={{ marginLeft: "auto", marginRight: "auto" }}>
            <Typography pt={3} px={3} style={{ fontWeight: 400, fontSize: "16px",textAlign: "center" }}>
              By selecting
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#6ebe44",
                }}
              >
                {" "}Accept{" "}
              </span>
              , you agree that this job post reflects your requirements, and you
              will be logged in to confirm your choice.
            </Typography>
            <Stack
              spacing={2}
              px={3}
              mt={3}
              pb={3}
              direction="row"
              justifyContent="end"
              alignItems="center"
            >
              <Button
                style={{ border: "1px solid #E2E8F0", color: "#EA4933" }}
                onClick={() => handleActionClick("Reject")}
                disabled={actionLoading}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                color="success"
                style={{ fontWeight: 500, fontSize: "14px" }}
                onClick={() => handleActionClick("Accept")}
                disabled={actionLoading}
              >
                {actionLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Accept Offer"
                )}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}

      {/* Offer Already Resolved */}
      {isOfferResolved && (
        <Grid
          container
          sx={{
            backgroundColor: "white",
            width: "100%",
            overflowX: "hidden",
            justifyContent: "center",
            padding: "30px",
          }}
        >
          <Grid item xs={12} sm={12}>
            <Alert severity="info">
              This job offer has already been{" "}
              {jobData?.cliniciansInFacilityJobShifts?.[0]?.offerStatus ===
              "OfferAccepted"
                ? "accepted"
                : "rejected"}
              .
            </Alert>
            <Button
              variant="contained"
              onClick={() => navigate("/login")}
              sx={{ mt: 2 }}
              fullWidth
            >
              Go to Login
            </Button>
          </Grid>
        </Grid>
      )}

      {/* Confirmation Dialog */}
      <Dialog open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to {pendingAction?.toLowerCase()} this job offer?
          </Typography>
        </DialogContent>
        <Stack direction="row" spacing={2} sx={{ p: 2, justifyContent: "flex-end" }}>
          <Button onClick={() => setShowConfirmDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleConfirmAction}
            disabled={actionLoading}
          >
            {actionLoading ? <CircularProgress size={24} /> : "Confirm"}
          </Button>
        </Stack>
      </Dialog>
    </>
  );
};

export default JobOfferEmailView;
